<template>
  <VanPopup
    :show="show"
    @update:show="$emit('update:show', $event)"
    class="w-full pt-10"
    :close-on-click-overlay="false"
    teleport="body"
    closeable
  >
    <ChatScenePositionItem
      :position="position!"
      :chat-scene="chatScene"
      @close-edit-modal="emit('closeEditModal')"
    />
  </VanPopup>
</template>
<script setup lang="ts">
import { ChatScene, ChatScenePosition } from "@/types/chat";
import { PropType } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  position: {
    type: Object as PropType<ChatScenePosition>,
    required: true,
  },
  chatScene: {
    type: Object as PropType<ChatScene>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
  (e: "closeEditModal"): void;
}>();
</script>
